<template>
  <div class="container_brand">
    <HomeHead></HomeHead>
    <el-image
      :src="require('../../assets/images/brand/aboutus.jpg')"
      fit="fill"
    ></el-image>
    <el-row>
      <el-col :md="{ span: 20, offset: 2 }">
        <div class="about_main">
          <h2>关于我们<em>ABOUT US</em></h2>
          <p>
            北京鹏宇成软件技术有限公司成立于2003年主要从事电力行业设计软件销售为主，主要销售产品：微软、Autodesk、ANSYS、Bentley、Adobe等。
            自2010年组建新的开发团队，开发软件产品并向互联网产品转型，拓展互联网相关的业务。
            随知和鹏保宝的产品前身是为设计企业提供文档加密保护软件系统，由新的团队通过技术的组合创新将应用场景扩展到互联网上，为知识付费提供知识产权的保护能力。
            企业投票云服务是基于电力行业相关评审业务推出的一款简单、易用、快速解决投票业务的产品。
            随着产品初步的研发到位，为了让产品更好的运营，在2014年将产品和人员全部转入北京创世泰克科技有限公司。2015年8月创世泰克公司完成了股份制改造。
          </p>
          <!-- <p>
            北京鹏宇成软件技术有限公司自主开发的互联网产品开会投票系统，不断结合广大用户的需求，经过不懈的探索创新，已形成了一套完整的服务体系，为客户提供多种会议投票模式。
          </p> -->
          <p>
            开会投票系统项目团队是一支克难攻坚、精益求精的队伍，以用户为中心，拥有极强的学习能力和战斗力，并期待产品服务更多的用户，不断推陈出新。在此也感谢为开会投票的发展提出过宝贵建议的亲们，感谢大家的支持与鼓励！
          </p>
          <p>开会投票客服热线：010-82800223</p>
          <p>服务QQ：929690091</p>
          <p>微信：13031051856</p>
          <p>邮箱：lishengwang@pyc.com.cn</p>
          <p>地址：北京市海淀区知春路6号锦秋国际大厦A座1602室</p>
        </div>
      </el-col>
    </el-row>
    <HomeFooter></HomeFooter>
  </div>
</template>
<script>
import HomeHead from '@/components/HomeHead.vue'
import HomeFooter from '@/components/HomeFooter.vue'
export default {
  components: {
    HomeHead,
    HomeFooter
  }
}
</script>
<style lang="less">
.about_main {
  margin-top: 50px;
  padding-bottom: 50px;
}
.about_main h2 {
  color: #333;
  font-size: 20px;
  font-weight: normal;
  background: url('../../assets/images/brand/xiahuaxian.png') no-repeat bottom
    left;
  height: 40px;
}
.about_main h2 em {
  color: #999;
  font-size: 14px;
  margin-left: 5px;
}
</style>
